module.exports = __webpack_public_path__ + "img/nissan-gt-r-case.4f671b52.jpg";